import { gsap, ScrollToPlugin } from "@gsap";

function initAnchorNav() {
	document.querySelectorAll(".anchor_nav-layout").forEach((layout) => {
		const nav = layout.querySelector(".anchor-nav");
		const list = layout.querySelector(".anchor-nav-list");
		const links = [...layout.querySelectorAll(".anchor-nav-link")]
			.map((link) => ({ link, target: document.getElementById(decodeURIComponent(link.hash.slice(1))) }))
			.filter(({ target }) => target);
		if (!nav || !links.length) return;

		const offset = () => layout.getBoundingClientRect().bottom;
		const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");

		const setStuck = () => {
			const top = parseFloat(getComputedStyle(layout).top) || 0;
			layout.classList.toggle("is-stuck", layout.getBoundingClientRect().top <= top + 1);
		};

		const setActive = () => {
			const line = offset() + 1;
			let active = null;
			links.forEach((item) => {
				if (item.target.getBoundingClientRect().top <= line) active = item;
			});
			links.forEach(({ link }) => link.toggleAttribute("aria-current", false));
			if (!active) return;
			active.link.setAttribute("aria-current", "true");
			const left = active.link.offsetLeft - (list.clientWidth - active.link.offsetWidth) / 2;
			list.scrollTo({ left, behavior: reduce.matches ? "auto" : "smooth" });
		};

		let tween = null;
		const stop = () => tween?.kill();
		["wheel", "touchstart", "keydown"].forEach((type) => window.addEventListener(type, stop, { passive: true }));

		links.forEach(({ link, target }) => {
			link.addEventListener("click", (event) => {
				event.preventDefault();
				stop();
				const y = window.scrollY + target.getBoundingClientRect().top - offset() + 1;
				tween = gsap.to(window, { duration: reduce.matches ? 0 : 0.8, ease: "power2.inOut", scrollTo: { y, autoKill: false } });
				history.replaceState(null, "", link.hash);
			});
		});

		let ticking = false;
		window.addEventListener("scroll", () => {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(() => {
				setStuck();
				setActive();
				ticking = false;
			});
		}, { passive: true });
		layout.addEventListener("transitionend", setStuck);
		setStuck();
		setActive();
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initAnchorNav);
} else {
	initAnchorNav();
}
